<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [text]="'ZURUECK' | translate"></ion-back-button>
    </ion-buttons>
    <ion-title>{{ 'FOTOS' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="padding-16">
    <div class="flex flex-column gap-16">
      @if (project(); as project) {
        <sfg-app-projekte-fotos [project]="project" />
      }
    </div>
  </div>
</ion-content>
